import { pluck } from 'ramda'
import { Provider } from '../PreCheckedProviders.types'

interface GetNamesAsStringParams {
  providers: Provider[]
  conjunction?: string
}

/**
 * Accepts a list of providers and returns the provider names as a comma
 * separated string if there is more than 1 provider, the last name will be
 * preceded by the conjunction
 *
 * @param providers - Array of providers
 * @param conjunction - Word to use before the last provider name (defaults to
 *   'or')
 * @returns Formatted string of provider names
 */
export const getNamesAsString = ({
  providers,
  conjunction = 'or',
}: GetNamesAsStringParams): string => {
  if (providers.length === 0) return ''

  // Extract provider names
  const names = pluck('providerName', providers)

  if (names.length === 1) {
    return names[0]
  } else {
    // Join provider names with commas and add a conjunction before the last name
    const lastProvider = names[names.length - 1]
    const otherProviders = names.slice(0, -1).join(', ')

    return `${otherProviders} ${conjunction} ${lastProvider}`
  }
}
